import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { GTM_SCRIPT_ID } from '@constants/gtm.constants';

@Injectable({
  providedIn: 'root',
})
export class GtmEnvService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  injectGtmScript(): void {
    const script = this.document.createElement('script');
    script.id = GTM_SCRIPT_ID;
    script.type = 'text/javascript';
    script.src = '/assets/config/gtm-env.js';
    this.document.head.appendChild(script);
  }

  removeGtmScript(): void {
    const script = this.document.getElementById(GTM_SCRIPT_ID);
    script && this.document.head.removeChild(script);
  }
}
